module.exports = __webpack_public_path__ + "static/media/mkidn.6986c4ed.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mkidn.webp
// module id = 246
// module chunks = 0